exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.11@core-js/modules/_wks-ext.js
// module id = 281
// module chunks = 0